import styled from 'styled-components';

export const PageWrapper = styled.div`
 padding: 0.9rem 0.5rem;
`;

export const PageTime = styled.div`
 font-size: 1rem;
`;
